import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/follow_on_job/'

export default {
  getBooking (baseUrl, id) {
    return axios.post(baseUrl + URL + `${id}/get`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  createSupportTicket (baseUrl, data) {
    return axios.get(baseUrl + URL + `createSupportTicket?booking_id=${data.bookingId}&text=${data.text}&type=${data.type}`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  getFollowOnJobsForTaxi (baseUrl, taxiId) {
    return axios.get(baseUrl + URL + `${taxiId}/list?taxiId=${taxiId}`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  updateFollowOnJobsPriority (baseUrl, data) {
    return axios.post(baseUrl + URL + `update_priority`, data).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
